function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";
import isNotEmpty from "../../../utils/isNotEmpty";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import PushOrg from "../../organisms/PushOrg";
import AdditionalInformationElement from "./components/AdditionalInformationElement";
import MainPriceElement from "./components/MainPriceElement";
import PromoTextElement from "./components/PromoTextElement";
import { elementsSpaces } from "./priceMol.config";
function PriceMol(_ref) {
  var mainPrice = _ref.mainPrice,
    badgeText = _ref.badgeText,
    additionalInformation = _ref.additionalInformation,
    regularPrice = _ref.regularPrice,
    lowestPrice = _ref.lowestPrice,
    variant = _ref.variant,
    hasCrossedPriceSafeSpace = _ref.hasCrossedPriceSafeSpace;
  var getPriceMolElement = function getPriceMolElement(priceVariant) {
    var spaces = elementsSpaces[priceVariant.type];
    var hasPriceBottomSpace = isNotEmpty(additionalInformation) && additionalInformation.length || isNotEmpty(regularPrice) && isNotEmpty(lowestPrice);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: hasPriceBottomSpace ? spaces.mainPrice : 0
    }, /*#__PURE__*/React.createElement(AlignContentOrg, {
      horizontalAlignType: "both",
      horizontalAlign: priceVariant.align
    }, /*#__PURE__*/React.createElement(MainPriceElement, {
      mainPrice: mainPrice,
      badgeText: badgeText,
      hasPromo: isNotEmpty(mainPrice.crossedPrice) && isNotEmpty(regularPrice) && isNotEmpty(lowestPrice),
      variant: priceVariant,
      hasCrossedPriceSafeSpace: hasCrossedPriceSafeSpace
    }))), isNotEmpty(additionalInformation) ? /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: spaces.additionalInformation
    }, /*#__PURE__*/React.createElement(AdditionalInformationElement, {
      additionalInformation: additionalInformation,
      variant: priceVariant
    })) : null, isNotEmpty(regularPrice) && isNotEmpty(lowestPrice) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: 1
    }, /*#__PURE__*/React.createElement(PromoTextElement, {
      text: regularPrice.text,
      price: regularPrice.price,
      percent: regularPrice.percent,
      variant: priceVariant
    })), /*#__PURE__*/React.createElement(PromoTextElement, {
      text: lowestPrice.text,
      price: lowestPrice.price,
      percent: lowestPrice.percent,
      variant: priceVariant
    })) : null);
  };
  if (_typeof(variant) === "object" && isNotEmpty(variant.small)) {
    var variantBreakpoints = variant;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
      from: "small",
      to: "medium"
    }, getPriceMolElement(variantBreakpoints.small)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
      from: "medium",
      to: "large"
    }, getPriceMolElement(variantBreakpoints.medium)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
      from: "large"
    }, getPriceMolElement(variantBreakpoints.large)));
  }
  return getPriceMolElement(variant);
}
export default PriceMol;